import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

const Header = () => {
  return (
    <div className="section" id="home">
      <div className="container">
        <div className="header-wrapper">
          <Fade bottom>
            <div className="col">
              <h2>
                <div className="heading-wrapper">
                  <img className="profile" src={data.aboutImage}></img>
                  Hi, I'm {data.name}{" "}
                  <span role="img" aria-label="Emoji">
                    👋.
                  </span>
                  <h2>
                    I am building tools to solve my own problems. Here are some
                    highlights.
                    {/* {data.headerTagline[0]
                      ? data.headerTagline[0]
                      : "Building digital"}
                  </h2>
                  <h2>
                    {" "}
                    {data.headerTagline[1]
                      ? data.headerTagline[1]
                      : "products, brands"}
                  </h2>
                  <h2>
                    {" "}
                    {data.headerTagline[2]
                      ? data.headerTagline[2]
                      : "and experience"} */}
                  </h2>
                  <p>{data.headerParagraph}</p>
                </div>
              </h2>
            </div>
          </Fade>
          <Fade bottom></Fade>
          <Fade bottom className="row">
            {/* Product builder at Co. @ New. Product Hunt #1 & Lifehacker (I Lazy to Read). Hacker Noon 2020 Noonies Winner. Product & community consulting for tech cos (US/APAC). */}
            <a href="https://alysiawu.github.io/" className="primary-btn">
              Get to know me →
            </a>
            {/* <a
              href={`mailto:${
                data.contactEmail ? data.contactEmail : "alysiawu886@gmail.com"
              }`}
              className="primary-btn"
              >
                
              
            </a> */}
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Header
